import { SectionPlane, SectionPlanesPlugin } from "@xeokit/xeokit-sdk";
import { TreeViewCacheItem, TreeviewModel } from "../../Models/Treeview";
import { GroupviewCacheItem, GroupviewModel } from "@/Models/Groupview";
import { TreeRenderElement } from "@/components/ObjectViews/TreeviewRenderer";

export enum ActionType {
  AddSelectedEntities = "AddSelectedEntities",
  RemoveSelectedEntity = "RemoveSelectedEntity",
  SetSelectedEntities = "SetSelectedEntities",
  AddHighlightedEntities = "AddHighlightedEntities",
  RemoveHighlightedEntities = "RemoveHighlightedEntities",
  SetHighlightedEntities = "SetHighlightedEntities",
  AddInvisibleEntities = "AddInvisibleEntities",
  RemoveInvisibleEntities = "RemoveInvisibleEntities",
  SetInvisibleEntities = "SetInvisibleEntities",
  ScheduleIsolatedMeasure = "ScheduleIsolatedMeasure",
  StopIsolatedMeasure = "StopIsolatedMeasure",
  SetPickerIsEnabled = "SetPickerIsEnabled",
  SetOpenPlugin = "SetOpenPlugin",
  SetSectionPlanePlugin = "SetSectionPlanePlugin",
  SetSectionPlanes = "SetSectionPlanes",
  SetProjection = "SetProjection",
  SetTreeViewCache = "SetTreeViewCache",
  SetGroupViewCache = "SetGroupViewCache",
  SetGridVisibility = "SetGridVisibility",
  SetSpaceVisibility = "SetSpaceVisibility",
  ToggleAddingSectionPlane = "ToggleAddingSectionPlane",
  ToggleInvisibleAsXray = "ToggleInvisibleAsXray",
  SetTreeviewObjects = "SetTreeviewModel",
  SetGroupviewObjects = "SetGroupviewModel",
  SetTreeviewRender = "SetTreeviewRender",
  SetGroupviewRender = "SetGroupviewRender",
  AddXrayedEntities = "ADD_XRAYED_ENTITIES",
  RemoveXrayedEntities = "REMOVE_XRAYED_ENTITIES",
  SetXrayedEntities = "SET_XRAYED_ENTITIES",
}

export interface AddSelectedEntities {
  type: ActionType.AddSelectedEntities;
  entities: string[];
}
export interface RemoveSelectedEntity {
  type: ActionType.RemoveSelectedEntity;
  entities: string[];
}

export interface SetSelectedEntities {
  type: ActionType.SetSelectedEntities;
  entities: string[];
}
export interface AddHighlightedEntities {
  type: ActionType.AddHighlightedEntities;
  entities: string[];
}
export interface RemoveHighlightedEntities {
  type: ActionType.RemoveHighlightedEntities;
  entities: string[];
}
export interface SetHighlightedEntities {
  type: ActionType.SetHighlightedEntities;
  entities: string[];
}
export interface AddInvisibleEntities {
  type: ActionType.AddInvisibleEntities;
  entities: string[];
}
export interface RemoveInvisibleEntities {
  type: ActionType.RemoveInvisibleEntities;
  entities: string[];
}

export interface SetInvisibleEntities {
  type: ActionType.SetInvisibleEntities;
  entities: string[];
}

export interface ScheduleIsolatedMeasure {
  type: ActionType.ScheduleIsolatedMeasure;
  entities: string[];
}
export interface StopIsolatedMeasure {
  type: ActionType.StopIsolatedMeasure;
}
export interface SetPickerIsEnabled {
  type: ActionType.SetPickerIsEnabled;
  enabled: boolean;
}

export interface SetOpenPlugin {
  type: ActionType.SetOpenPlugin;
  plugin: "" | "SectionPlanes" | "Measurer";
}

export interface SetSectionPlanePlugin {
  type: ActionType.SetSectionPlanePlugin;
  sectionPlane: SectionPlanesPlugin;
}

export interface SetSectionPlanes {
  type: ActionType.SetSectionPlanes;
  sectionPlanes: SectionPlane[];
}
export interface SetProjection {
  type: ActionType.SetProjection;
  projection: "perspective" | "ortho" | "frustum";
}
export interface SetTreeViewCache {
  type: ActionType.SetTreeViewCache;
  treeViewCacheItem: TreeViewCacheItem[];
}

export interface SetGroupViewCache {
  type: ActionType.SetGroupViewCache;
  groupViewCacheItem: GroupviewCacheItem[];
}

export interface SetGridVisibility {
  type: ActionType.SetGridVisibility;
  visible: boolean;
}

export interface SetSpaceVisibility {
  type: ActionType.SetSpaceVisibility;
  visible: boolean;
}

export interface ToggleAddingSectionPlane {
  type: ActionType.ToggleAddingSectionPlane;
  active: boolean;
}

export interface ToggleInvisibleAsXray {
  type: ActionType.ToggleInvisibleAsXray;
  active: boolean;
}

export interface SetTreeviewObjects {
  type: ActionType.SetTreeviewObjects;
  treeviewObjects: TreeviewModel[];
}
export interface SetGroupviewObjects {
  type: ActionType.SetGroupviewObjects;
  groupviewObjects: GroupviewModel[][];
}

export interface SetTreeviewRender {
  type: ActionType.SetTreeviewRender;
  treeviewRender: TreeRenderElement[];
}
export interface SetGroupviewRender {
  type: ActionType.SetGroupviewRender;
  groupviewRender: TreeRenderElement[];
}

export interface AddXrayedEntities {
  type: ActionType.AddXrayedEntities;
  entities: string[];
}

export interface RemoveXrayedEntities {
  type: ActionType.RemoveXrayedEntities;
  entities: string[];
}

export interface SetXrayedEntities {
  type: ActionType.SetXrayedEntities;
  entities: string[];
}

export type ViewerActions =
  | AddSelectedEntities
  | RemoveSelectedEntity
  | SetSelectedEntities
  | AddHighlightedEntities
  | RemoveHighlightedEntities
  | SetHighlightedEntities
  | AddInvisibleEntities
  | RemoveInvisibleEntities
  | SetInvisibleEntities
  | ScheduleIsolatedMeasure
  | StopIsolatedMeasure
  | SetPickerIsEnabled
  | SetOpenPlugin
  | SetSectionPlanePlugin
  | SetSectionPlanes
  | SetProjection
  | SetTreeViewCache
  | SetGroupViewCache
  | SetGridVisibility
  | SetSpaceVisibility
  | ToggleAddingSectionPlane
  | ToggleInvisibleAsXray
  | SetTreeviewObjects
  | SetGroupviewObjects
  | SetTreeviewRender
  | SetGroupviewRender
  | AddXrayedEntities
  | RemoveXrayedEntities
  | SetXrayedEntities;